import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import { ClipboardCheck, SearchCheck, FileSignature, KeyRound } from "lucide-react";

const STEPS = [
  { icon: ClipboardCheck, title: "Apply online", body: "Quick pre-qualifier first, then the full application — all from your phone." },
  { icon: SearchCheck, title: "We verify", body: "Identity, licence, income and affordability — assessed fairly, never auto-declined." },
  { icon: FileSignature, title: "Sign with clarity", body: "A written, vehicle-specific quotation and agreement. You see everything first." },
  { icon: KeyRound, title: "Drive to ownership", body: "Collect your car and watch your ownership balance fall, statement by statement." },
];

export default function HowItWorks() {
  return (
    <section data-testid="how-it-works-section" className="py-24 md:py-32 relative overflow-hidden">
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.3em] text-sky-300 font-bold mb-4">How it works</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-black text-white max-w-2xl mb-16">
            From application to keys in four steps.
          </h2>
        </Reveal>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {STEPS.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.1}>
              <div data-testid={`how-step-${i + 1}`} className="relative border border-sky-300/20 rounded-xl p-8 bg-[#122659]/60 h-full">
                <span className="font-display text-sm font-black text-[#F57C00] tracking-widest">STEP {i + 1}</span>
                <s.icon size={30} className="text-sky-300 my-5" />
                <h3 className="font-display text-lg font-bold text-white mb-2">{s.title}</h3>
                <p className="text-sm text-slate-400 leading-relaxed">{s.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal>
          <div className="rounded-2xl border border-[#F57C00]/30 bg-gradient-to-r from-[#F57C00]/15 via-[#122659] to-[#122659] p-10 md:p-14 flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
            <div>
              <h3 className="font-display text-2xl md:text-3xl font-black text-white mb-2">
                Two minutes to know where you stand.
              </h3>
              <p className="text-slate-400 text-sm md:text-base max-w-lg">
                Our pre-qualifier gives you a provisional answer instantly — no obligation, no paperwork.
              </p>
            </div>
            <Link
              to="/pre-qualify"
              data-testid="how-cta-btn"
              className="shrink-0 bg-[#F57C00] hover:bg-[#E67300] text-white font-bold px-8 py-4 rounded-md transition-all duration-300 hover:-translate-y-1"
            >
              Start pre-qualification
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
